import moment from "moment";
import 'moment/locale/sv';
import { Tendering, TenderingFeeReportPeriod } from "../models/tendering";

export function getOpenReportPeriod(tendering: Tendering): TenderingFeeReportPeriod | undefined {
  let report;
  moment.locale('sv')
  if (!tendering.tenderingFeeReports) {
    return undefined;
  }

  tendering.tenderingFeeReports.forEach(r => {
    var compareDate = moment();
    var startDate   = moment(r.periodStart, 'YYYY-MM-DD');
    var endDate     = moment(r.periodEnd, 'YYYY-MM-DD');

    if (compareDate.isBetween(startDate, endDate)) {
      report = r;
    }
  });
  
  return report;
}

export function getLastReportPeriod(tendering: Tendering): TenderingFeeReportPeriod | undefined {
  let report;
  moment.locale('sv')
  if (!tendering.tenderingFeeReports) {
    return undefined;
  }

  tendering.tenderingFeeReports.forEach(r => {
    var compareDate = moment();
    var startDate   = moment(r.periodStart, 'YYYY-MM-DD');
    var endDate     = moment(r.periodEnd, 'YYYY-MM-DD').add(30, 'days');

    if (compareDate.isBetween(startDate, endDate)) {
      report = r;
    }
  });
  
  return report;
}

export function getOngoingReportPeriod(tendering: Tendering): TenderingFeeReportPeriod | undefined {
  let report;
  moment.locale('sv')
  if (!tendering.tenderingFeeReports) {
    return undefined;
  }

  tendering.tenderingFeeReports.forEach(r => {
    var compareDate = moment();
    var startDate   = moment(r.periodStart, 'YYYY-MM-DD');
    var endDate     = moment(r.deadlineDate, 'YYYY-MM-DD');

    if (compareDate.isBetween(startDate, endDate)) {
      report = r;
    }
  });
  
  return report;
}

export function getOngoingReportPeriods(tendering: Tendering): TenderingFeeReportPeriod[] | undefined {
  let report: TenderingFeeReportPeriod[] = [];
  moment.locale('sv')
  if (!tendering.tenderingFeeReports) {
    return undefined;
  }

  tendering.tenderingFeeReports.forEach(r => {
    var compareDate = moment();
    var startDate   = moment(r.periodStart, 'YYYY-MM-DD');
    var endDate     = moment(r.deadlineDate, 'YYYY-MM-DD');

    if (compareDate.isSameOrAfter(startDate)) {
      report.push(r);
    }
  });
  
  return report;
}

export function getReportPeriod(tendering: Tendering, reportID: string): TenderingFeeReportPeriod | undefined {
  let report;
  if (!tendering.tenderingFeeReports) {
    return undefined;
  }

  report = tendering.tenderingFeeReports.find(r => r.reportID === reportID);
  
  return report;
}